module.exports = __webpack_public_path__ + "static/media/GraphikSemibold.99c54fc5.otf";